import React, { useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import backgroundSvg from "../../assets/svgs/BgAzvasa.svg";
import { DiagnosticTestInfo2 } from "../../components/diagnosticTestV2/DiagnosticTestInfo2";
import { useCourse } from "../course/hooks";

const useStyles = makeStyles()((theme) => ({
  root: {
    minHeight: "calc(100vh - 96px)",
    background: "#f0f8ff",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  decorativeCircle1: {
    position: "absolute",
    top: -100,
    left: -100,
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "radial-gradient(circle, #ff9a9e 0%, #fad0c4 100%)",
  },
  decorativeCircle2: {
    position: "absolute",
    bottom: -50,
    right: -50,
    width: 150,
    height: 150,
    borderRadius: "50%",
    background: "radial-gradient(circle, #a1c4fd 0%, #c2e9fb 100%)",
    zIndex: 1,
  },
  bgImage: {
    position: "absolute",
    minHeight: "600px",
    height: "100%",
    bottom: "-50px",
    // right: '-20px',
    width: "100%",
    zIndex: 0,
  },
  container: {
    py: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    height: "calc(100vh - 96px)",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#4a4a4a",
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  },
  subtitle: {
    color: "#5a5a5a",
  },
  gridContainer: {
    display: "grid",
    // gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
    width: "100%",
  },
  button: {
    fontSize: "1.2rem",
    padding: "12px 24px",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
    },
  },
  infoItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
    },
  },
  iconWrapper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  infoTitle: {
    marginBottom: theme.spacing(1),
    color: "#4a4a4a",
    fontWeight: 500,
  },
  infoContent: {
    color: "#5a5a5a",
    textAlign: "center",
  },

  //new ui ---
  welcomeBox: {
    background: "#29ABE233",
    minHeight: "85dvh",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  welcomeContentBox: {
    backgroundImage: `url(${backgroundSvg})`,
    backgroundSize: "center",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "calc(100vh - 100px)",
  },
  welcomeGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  welcomeText: {
    color: "#FF716F",
    fontWeight: 700,
    fontFamily: '"milkshake", "Quicksand", cursive',
    textShadow: `-1px -1px 0 white,
                                1px -1px 0 white,
                                -1px 1px 0 white,
                                1px 1px 0 white,
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white,
                                -3px -3px 0 white,
                                3px -3px 0 white,
                                -3px 3px 0 white,
                                3px 3px 0 white,
                                -4px -4px 0 white,
                                4px -4px 0 white,
                                -4px 4px 0 white,
                        4px 4px 0 white`,
  },
  studentText: {
    color: "#2D9CDB",
    fontWeight: 700,
    fontFamily: '"Quicksand", sans-serif',
    textShadow: `
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white
                            `,
  },
}));

const Welcome = ({ student, onClickCta, selectedTest }) => {
  const { classes } = useStyles();
  const { loadCurrent, current } = useCourse();

  const numberToOrdinal = (n) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = n % 100;
    const suffix =
      suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
    return n + suffix;
  };

  useEffect(() => {
    if (selectedTest && selectedTest?.courseId) {
      const courseId = selectedTest?.courseId;
      loadCurrent({ id: courseId });
    }
  }, [selectedTest]);

  return (
    <Box className={classes.welcomeBox}>
      <Box
        className={classes.welcomeContentBox}
        sx={{
          minHeight: { xs: "80vh", sm: "70vh" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Grid container sx={{ mt: { xs: 2, sm: 4, md: 8 } }}>
          <Grid className={classes.welcomeGrid} item xs={12}>
            <Typography
              className={classes.welcomeText}
              sx={{
                fontSize: {
                  xs: "2.3em",
                  sm: "2.4em",
                  md: "2.8em",
                  lg: "3.8em",
                  xl: "4.8em",
                },
              }}
            >
              Welcome
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            item
            xs={12}
          >
            <Typography
              sx={{
                color: "#000",
                fontWeight: 700,
                fontSize: { xs: "1em", md: "1.2em", lg: "1.4em" },
                fontFamily: '"Quicksand", sans-serif',
              }}
            >
              to your Learning Adventure
            </Typography>
          </Grid>
          <Grid className={classes.welcomeGrid} item xs={12}>
            <Typography
              className={classes.studentText}
              sx={{
                fontSize: {
                  xs: "1em",
                  sm: "1em",
                  md: "1.3em",
                  lg: "1.8em",
                  xl: "2.3em",
                },
              }}
            >
              {student.firstName} {student.lastName}!
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            item
            xs={12}
          >
            <Typography
              sx={{
                color: "#000",
                fontWeight: 700,
                fontSize: { xs: "0.8em", md: "1.2em", lg: "1.4em" },
                fontFamily: '"Quicksand", sans-serif',
              }}
            >
              This is a diagnostic test to assign a reading course.
            </Typography>
          </Grid>
          <Grid
            className={classes.welcomeGrid}
            sx={{ marginTop: 3 }}
            item
            xs={12}
          >
            {/* <Button variant="contained" size="large" placeholder="Begin Your Diagnostic Test!" className={classes.button} onClick={onClickCta} /> */}
            <DiagnosticTestInfo2 onClickCta={onClickCta} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const InfoItem = ({ icon, title, content, color }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.infoItem}>
      <Box className={classes.iconWrapper} style={{ backgroundColor: color }}>
        {React.cloneElement(icon, { style: { color: "white" } })}
      </Box>
      <Typography variant="h6" className={classes.infoTitle}>
        {title}
      </Typography>
      <Typography variant="body1" className={classes.infoContent}>
        {content}
      </Typography>
    </Box>
  );
};

export default Welcome;
